import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function TermsDescriptions({ description }) {
  return (
    <section className="privacy-description-sec" id="privacy-description-sec">
      <Container fluid className="wrap">
        <Row>
          <Col md={12}>
            <div
              className="privacy-desc-div"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default TermsDescriptions;
